<div>
  <div class="header flex justify-between">
    <p>Patientendownload - {{ state.progress }}%</p>
    <p (click)="_modalCtrl.dismiss()">X</p>
  </div>
  <div class="flex flex-col p-4 patient-data">
    <div class="flex flex-row justify-between">
      <span>{{ patient.gender | salutationPipe }} </span>
      <div
        class="status-type"
        *ngIf="patient.nursingHomeId"
        [ngClass]="{ disabled: !patient.accountingStatus || patient.deactivationReason }"
      >
        <ion-icon name="alberta-nursinghome"></ion-icon> {{ 'patient.stationary' | translate }}
      </div>
      <div
        class="status-type"
        *ngIf="!patient.nursingHomeId"
        [ngClass]="{ disabled: !patient.accountingStatus || patient.deactivationReason }"
      >
        <ion-icon name="alberta-outpatient"></ion-icon>{{ 'patient.outpatient' | translate }}
      </div>
    </div>

    <p>{{ patient.firstName }} {{ patient.lastName }}</p>
    <span>geb. {{ patient.birthday | date : 'dd.MM.yyyy' }}</span>
  </div>
  <p class="bold p-4 text-center download-title">Folgende Datensätze werden geladen:</p>
  <div class="download-data">
    <div
      *ngFor="let step of state.steps; let i = index"
      class="step"
      [ngClass]="[step.status, i === state.steps.length - 1 ? 'save-step' : '']"
    >
      <span>{{ step.label }}</span>
      <ion-icon *ngIf="step.status === DownloadStepStatus.Pending" name="hourglass-outline"></ion-icon>
      <ion-spinner *ngIf="step.status === DownloadStepStatus.Active" name="crescent"></ion-spinner>
      <ion-icon *ngIf="step.status === DownloadStepStatus.Done" name="checkmark-circle"></ion-icon>
    </div>
  </div>
</div>
